import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../data/content";
import { SectionHeading } from "./SectionHeading";
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="px-4 py-14 sm:px-5 sm:py-20" data-id="element-55" data-mp="1gd7hib8p3f72">
      <SectionHeading eyebrow="QUESTIONS FRÉQUENTES" title={<>Avant de <span className="text-gold" data-id="element-57" data-mp="2dzeo1qok7hm2">vous décider</span></>} data-id="element-56" data-mp="1gakztis3bjb4" />
      <div className="mx-auto mt-10 max-w-3xl divide-y divide-line border-y border-line" data-id="element-58" data-mp="291d28xzr146w">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} data-id="element-59" data-mp="244cv0jr5xve7" data-mpi={i}>
              <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-4 text-left text-base font-semibold text-cream sm:py-5 sm:text-lg" data-id="element-60" data-mp="1z3feeblsx9et">
                {f.q}
                <PlusIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden data-id="element-61" data-mp="phejs4expfge" />
              </button>
              <AnimatePresence initial={false} data-id="element-62" data-mp="fiyqpvwcjw49">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-63" data-mp="ki1xplvw0cev">
                    <p className="pb-5 text-mute" data-id="element-64" data-mp="3t0hhho62th8c">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </section>;
}